import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    text: String
  }

  copy() {
    const text = this.textValue

    navigator.clipboard.writeText(text)
  }
}
